import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class MaximumDepositLimitConfig {
	constructor(private config: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	isMaximumDepositLimitEnabled(): boolean {
		return this.config.get(
			(x) => x.commonUi.responsibleGaming.maximumDepositLimit!.isMaximumDepositLimitEnabled,
			false
		);
	}

	getDailyDepositLimitMaxValue(): number {
		return this.config.get((x) => x.commonUi.responsibleGaming.maximumDepositLimit!.dailyDepositLimitMax, Infinity);
	}

	getWeeklyDepositLimitMaxValue(): number {
		return this.config.get(
			(x) => x.commonUi.responsibleGaming.maximumDepositLimit!.weeklyDepositLimitMax,
			Infinity
		);
	}

	getMonthlyDepositLimitMaxValue(): number {
		return this.config.get(
			(x) => x.commonUi.responsibleGaming.maximumDepositLimit!.monthlyDepositLimitMax,
			Infinity
		);
	}

	getDepositLimitMaxThresholdValue(): number {
		return this.config.get((x) => x.commonUi.responsibleGaming.setDepositLimitMax, Infinity);
	}
}
